















import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Ref } from 'vue-property-decorator';

// Store types
import { ToolSystemSuggestionMap } from '@/store/store.types';

// Actual space
import SystemSpace from './SystemsSpace.vue';

/**
 *  Component that renders all the spaces for which system suggestions were returned.
 */
@Component({
    components: {
        SystemSpace,
    },
})
export default class SystemSpaces extends Vue {

    /**
     *  Holding references to all the system spaces.
     */
    @Ref('systemSpace')
    private systemSpaces!: Array<SystemSpace>;

    /**
     *  The suggestions, returned for every space
     *  (single) or combination of spaces (multi).
     */
    @Prop({ type: Object, required: true })
    private suggestions!: ToolSystemSuggestionMap;

    /**
     *
     *  Used to get the fact if one of the spaces is valid.
     *
     *  (i) Users are allowed to only request airconditioning for one room
     *
     */
    public get valid(): boolean {

        let valid = false;

        for (const systemSpace of this.systemSpaces) {

            if (!systemSpace.valid) {

                continue;

            }

            valid = true;

            break;

        }

        return valid;

    }

}
